import { render, staticRenderFns } from "./RegisterSteps.vue?vue&type=template&id=01728e74&scoped=true&"
import script from "./RegisterSteps.vue?vue&type=script&lang=js&"
export * from "./RegisterSteps.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSteps.vue?vue&type=style&index=0&id=01728e74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01728e74",
  null
  
)

export default component.exports